import React, { useEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import Aside from '../Aside';
import { Button, EButtonType } from '@repo/apg-ui';
import ModalBackdrop from '../ModalBackdrop';
import Sidebar from '../Sidebar';
import './ServiceDesk.scss';
import { FormattedMessage } from 'react-intl';

interface Props {
  intl: any;
}

export const ServiceDesk = (props: Props) => {
  const [isServiceDeskOpen, setIsServiceDeskOpen] = useState<boolean>(false);

  const filterModalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      filterModalRef.current &&
      !filterModalRef.current.contains(event.target) &&
      !event.target.className.includes('serviceDesk-sidebar-content')
    ) {
      setIsServiceDeskOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <Transition in={isServiceDeskOpen} timeout={50}>
        {(state) => (
          <ModalBackdrop duration={250} state={state}>
            <Sidebar className='serviceDesk-sidebar' duration={250} state={state}>
              {isServiceDeskOpen && (
                <div className='serviceDesk-sidebar-content h-100' ref={filterModalRef}>
                  <Aside step={0} closeAside={setIsServiceDeskOpen} />
                </div>
              )}
            </Sidebar>
          </ModalBackdrop>
        )}
      </Transition>

      <div className='service-desk-wrapper'>
        <Button
          buttonType={EButtonType.BasicLink}
          onClick={() => {
            setIsServiceDeskOpen(true);
          }}
        >
          <FormattedMessage
            id='ec.components.buttons.HelpServiceDesk'
            defaultMessage='Hilfe{separator}ServiceDesk'
            values={{ separator: <br /> }}
          />
        </Button>
      </div>
    </>
  );
};
